import * as React from 'react';
import { RouteComponentProps, Switch } from 'react-router';

import { PrivateRoute } from 'src/router';


import * as Permissions from "../permissions";
import { RulesListController } from './rules/list/rules-list.controller';
import { RulesFormController } from './rules/form/rules-form.controller';
import { RuleStackTraceListController } from './rules/stacktrace/rule-stacktrace-list.controller';

export class RulesController extends React.Component<RouteComponentProps<any>, any> {
	render() {
		const match = this.props.match;
		return (
			<Switch>
				<PrivateRoute
					path={`${match.url}/stacktrace/:id`}
					component={RuleStackTraceListController}
					permissions={Permissions.ruleWritePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/rules/:id`}
					component={RulesFormController}
					permissions={Permissions.ruleWritePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/rules`}
					component={RulesListController}
					permissions={Permissions.rulePermission}
					{...this.props}
				/>

			</Switch>
		);
	}
}     



// WEBPACK FOOTER //
// ./src/app/rules/rules.controller.tsx